// This function allow to reference all chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 524 ? "app" : chunkId) + "." + __webpack_require__.h() + ".js";
};